import React from 'react';
import { useInfiniteHits } from 'react-instantsearch';
import { useSearchListContext } from '../context/SearchListProvider';
import SearchTeaser from './SearchTeaser';

const SearchListResults = () => {
  const { i18n, resultsHidden } = useSearchListContext();

  const { hits, isLastPage, showMore } = useInfiniteHits({
    showPrevious: false,
    escapeHTML: false
  });

  if (hits.length === 0 || resultsHidden) return null;

  return (
    <div className="search-list__results">
      <p className="typo-copy-small">{i18n.searchResults}</p>

      <div className="search-list__hits">
        {hits.map((item: any) => (
          <SearchTeaser key={item.id} {...item} />
        ))}
      </div>

      {!isLastPage && (
        <div className="search-list__load-more">
          <button
            className="button button--secondary"
            type="button"
            onClick={showMore}
          >
            <span className="typo-button">{i18n.loadMore}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchListResults;
